import React from 'react';
import { Sun, Moon, FileText, EyeOff, History, LogOut, Box, Layers, Zap } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';
import { useApp } from '../../context/AppContext';
import { useAuth } from '../../context/AuthContext';

export const Header: React.FC = () => {
  const { isDark, toggleTheme } = useTheme();
  const {
    singleViewMode,
    toggleSingleView,
    setIsHistoryOpen,
    activeView,
    setActiveView,
  } = useApp();
  const { session, logout } = useAuth();

  return (
    <header>
      <div className="brand" onClick={() => setActiveView('TAKEOFF')} style={{ cursor: 'pointer' }}>
        <Sun className="h-6 w-6 text-amber-500 fill-amber-500" />
        <span>Helios One</span>
      </div>

      {/* Main View Mode Navigation Switcher */}
      <nav className="header-view-nav">
        <button
          type="button"
          className={`nav-tab-btn ${activeView === 'TAKEOFF' ? 'active' : ''}`}
          onClick={() => setActiveView('TAKEOFF')}
        >
          <FileText className="h-4 w-4" />
          <span>Plan Takeoff</span>
        </button>

        <button
          type="button"
          className={`nav-tab-btn ${activeView === 'MATERIAL_LIST' ? 'active' : ''}`}
          onClick={() => setActiveView('MATERIAL_LIST')}
        >
          <Layers className="h-4 w-4 text-amber-500" />
          <span>Material List (BOM)</span>
        </button>
      </nav>

      <div className="header-actions">
        {/* Dark/Light mode switch */}
        <button
          className="theme-switch"
          type="button"
          role="switch"
          aria-checked={isDark}
          title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
          onClick={toggleTheme}
        >
          <div className="theme-switch-track">
            <Sun className="h-3 w-3 text-amber-500" />
            <Moon className="h-3 w-3 text-slate-400" />
          </div>
          <div className="theme-switch-thumb">
            {isDark ? (
              <Moon className="h-3 w-3 text-amber-400" />
            ) : (
              <Sun className="h-3 w-3 text-amber-500" />
            )}
          </div>
        </button>

        {/* Show/Hide PDF toggle (only relevant in Takeoff mode) */}
        {activeView === 'TAKEOFF' && (
          <button
            type="button"
            className={`btn-action ${singleViewMode ? 'btn-primary' : ''}`}
            onClick={toggleSingleView}
          >
            {singleViewMode ? (
              <>
                <FileText className="h-4 w-4" />
                <span>Show PDF</span>
              </>
            ) : (
              <>
                <EyeOff className="h-4 w-4" />
                <span>Hide PDF</span>
              </>
            )}
          </button>
        )}

        {/* History drawer trigger */}
        <button
          type="button"
          className="btn-action"
          onClick={() => setIsHistoryOpen(true)}
        >
          <History className="h-4 w-4" />
          <span>History</span>
        </button>

        {/* Logout / User */}
        {session?.authenticated && (
          <button
            type="button"
            className="btn-action"
            title={`Signed in as ${session.userName || session.userEmail || 'User'}`}
            onClick={logout}
          >
            <LogOut className="h-4 w-4" />
            <span>Sign Out</span>
          </button>
        )}
      </div>
    </header>
  );
};
